import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { GoalHelpers, GoalService } from 'projects/ey-nav-web-components/src';
import { first, switchMap, tap } from 'rxjs/operators';
import { BaseRouteConfigService } from '@EYN/lib';

@Injectable()
export class CanAccessLastModifiedPlan implements CanActivate {
	constructor(private goalService: GoalService,
				private baseRouteConfig: BaseRouteConfigService,
				private router: Router,
	) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<any> {
		const data = this.baseRouteConfig.data;
		const goal = data.pipe(switchMap(({ goalType }) => this.goalService.getGoal(goalType)));
		return combineLatest([data, goal])
			.pipe(first(), tap(([{ summaryRoute }, { plans }]) => {
				const lastModifiedPlan = plans
						.find(p => p.isLastModified && GoalHelpers.planHasStarted(p))
					|| plans.find(GoalHelpers.planHasStarted);
				if (lastModifiedPlan) {
					this.router.navigate([`${summaryRoute}/${lastModifiedPlan.planType}`]);
				}
			}));
	}
}
